import axios from "axios";
import LocalStorageKeys from "./localstorageKeys";
import ApiEndpoints from "./apiEndPoints";

const httpClient = (contentType = "application/json") => {
  const instance = axios.create({
    baseURL: ApiEndpoints.baseApiURL,
    withCredentials: true,
    headers: {
      "Content-Type": contentType,
    },
    validateStatus: function (status) {
      return status <= 500;
    },
  });
  instance.interceptors.request.use(function (config) {
    const token = localStorage.getItem(LocalStorageKeys.adminToken);
    config.headers.Authorization = token ? `Bearer ${token}` : "";
    return config;
  });
  return instance;
};

export default httpClient;
